import type { IntegracaoWppData, TemplateData } from "../../../services/integracaoWhatsapp"

export enum IntegracaoWhatsappActionsTypes {
    CARREGAR = "CARREGAR",
    CARREGAR_TEMPLATES = "CARREGAR_TEMPLATES",
    ATUALIZAR_WABAID = "ATUALIZAR_WABAID",
    ATUALIZAR_ATIVO = "ATUALIZAR_ATIVO",
    CONFIRMAR_SAVE = "CONFIRMAR_SAVE",
    REMOVER_TEMPLATE = "REMOVER_TEMPLATE",
}

export type IntegracaoWhatsappActions =
    | { type: IntegracaoWhatsappActionsTypes.CARREGAR; payload: IntegracaoWppData }
    | { type: IntegracaoWhatsappActionsTypes.CARREGAR_TEMPLATES; payload: TemplateData[] }
    | { type: IntegracaoWhatsappActionsTypes.ATUALIZAR_WABAID; payload: string }
    | { type: IntegracaoWhatsappActionsTypes.ATUALIZAR_ATIVO; payload: boolean }
    | { type: IntegracaoWhatsappActionsTypes.CONFIRMAR_SAVE; payload: IntegracaoWppData }
    | { type: IntegracaoWhatsappActionsTypes.REMOVER_TEMPLATE; payload: string }
